module.exports = __webpack_public_path__ + "static/img/start.34490fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/MagazineSpyglass/start.jpg
// module id = jC3N
// module chunks = 1